import { createStyles, makeStyles } from '@material-ui/core/styles'

interface StyleProps {
  overflow: boolean
  padding: 'XL' | 'M' | 'XS'
}

const paddingMap: Record<StyleProps['padding'], [number, number, number]> = {
  XL: [1, 9, 1],
  M: [1, 5, 1],
  XS: [1, 3, 1],
}

export const useStyles = makeStyles((theme) =>
  createStyles({
    default: (props: StyleProps) => ({
      flex: 1,
      display: 'grid',
      gridTemplateColumns: '47.8rem 2.4fr',
      ...(props.overflow ? { height: '100%' } : { minHeight: 0 }),

      '& > aside': {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.8),
        padding: theme.spacing(...paddingMap[props.padding]),
        ...(props.overflow && { overflowY: 'auto' }),
      },

      '& > section': {
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      },
    }),

    compare: (props: StyleProps) => ({
      flex: 1,
      display: 'grid',
      gridTemplateColumns: '47.8rem 2.4fr',
      ...(props.overflow ? { height: '100%' } : { minHeight: 0 }),

      '& > aside': {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.8),
        padding: theme.spacing(...paddingMap[props.padding]),
        ...(props.overflow && { overflowY: 'auto' }),
      },

      '& > section': {
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(1),

        '& > div': {
          height: '100%',
          width: '100%',
          position: 'relative',
        },
      },
    }),
  }),
)
